import { Injectable } from '@angular/core';
import { PV_VIEW_STATE_KEY, StackPlanViewModel } from './sp-view-state.model';
import { BehaviorSubject } from 'rxjs';
import { Column } from '@miq/catalog';

export const defaultState: StackPlanViewModel = {
  isSmoothView: true,
  showNonRentableSpace: true,
  showUnaccountedSpace: false,
};

function loadState() {
  const storedState = sessionStorage.getItem(PV_VIEW_STATE_KEY);
  return storedState ? JSON.parse(storedState) : defaultState;
}

@Injectable()
export class StackPlanViewStateService {
  #state: BehaviorSubject<StackPlanViewModel> = new BehaviorSubject(loadState());
  #columns: BehaviorSubject<Column[]> = new BehaviorSubject<Column[]>([]);
  onStateChange$ = this.#state.asObservable();

  getColumns(): Column[] {
    return this.#columns.getValue();
  }

  setColumns(columns: Column[]): void {
    this.#columns.next(columns);
  }

  getState(): StackPlanViewModel {
    return this.#state.getValue();
  }

  #patchState(patch: Partial<StackPlanViewModel>): void {
    const state = this.#state.getValue();
    const nextState = { ...state, ...patch };
    sessionStorage.setItem(PV_VIEW_STATE_KEY, JSON.stringify(nextState));
    this.#state.next(nextState);
  }

  setPropertyId(id: number): void {
    this.#patchState({ id });
  }

  setPropertyType(propertyType: string): void {
    this.#patchState({ propertyType });
  }

  setShowUnaccountedSpace(showUnaccountedSpace: boolean): void {
    this.#patchState({ showUnaccountedSpace });
  }

  setShowNonRentableSpace(showNonRentableSpace: boolean): void {
    this.#patchState({ showNonRentableSpace });
  }

  setSmoothView(isSmoothView: boolean): void {
    this.#patchState({ isSmoothView });
  }

  reset(): void {
    this.#state.next(defaultState);
    this.#columns.next([]);
  }
}
